/*
  PM Embed loader for snippets/pm-embed.liquid.
  - An embed loads only when its card comes near the screen.
  - At most 4 embeds load at the same time; the rest wait their turn.
  - Embeds wait for marketing consent from Shopify's Customer Privacy API.
    Where no consent is needed, Shopify reports it as allowed and embeds load straight away.
    Until then the card's placeholder (a link to the post) stays.
  - In the theme editor embeds always load so they can be previewed.
*/
(function () {
  'use strict';

  if (window.pmEmbeds) {
    window.pmEmbeds.scan(document);
    return;
  }

  var MAX_LOADING = 4;
  var TIMEOUT_MS = 10000;
  var loading = 0;
  var queue = [];
  var waiting = [];
  var consent = false;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function pump() {
    while (loading < MAX_LOADING && queue.length) start(queue.shift());
  }

  function start(el) {
    loading++;
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      loading--;
      el.classList.add('is-loaded');
      pump();
    }

    var frame = document.createElement('iframe');
    frame.className = 'pm-embed__frame';
    frame.src = el.getAttribute('data-pm-embed-src');
    frame.title = el.getAttribute('data-pm-embed-title') || '';
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('scrolling', 'no');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture; clipboard-write; web-share');
    frame.addEventListener('load', done);
    setTimeout(done, TIMEOUT_MS);
    el.appendChild(frame);
  }

  function enqueue(el) {
    el.setAttribute('data-pm-embed-state', 'queued');
    queue.push(el);
    pump();
  }

  // Called when an embed comes near the screen.
  function want(el) {
    if (el.hasAttribute('data-pm-embed-state')) return;
    if (consent) {
      enqueue(el);
    } else {
      el.setAttribute('data-pm-embed-state', 'waiting');
      waiting.push(el);
    }
  }

  function updateConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    consent = designMode || !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
    if (!consent) return;
    var ready = waiting;
    waiting = [];
    ready.forEach(enqueue);
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          observer.unobserve(e.target);
          want(e.target);
        });
      }, { rootMargin: '400px 0px' })
    : null;

  function scan(root) {
    var els = (root || document).querySelectorAll('[data-pm-embed]:not([data-pm-embed-seen])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-pm-embed-seen', '');
      if (observer) observer.observe(el); else want(el);
    });
  }

  // Instagram's embed reports its height; size the frame to match.
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://www.instagram.com') return;
    var d = e.data;
    if (typeof d === 'string') {
      try { d = JSON.parse(d); } catch (err) { return; }
    }
    if (!d || d.type !== 'MEASURE' || !d.details || !d.details.height) return;
    var frames = document.querySelectorAll('.pm-embed--instagram .pm-embed__frame');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === e.source) {
        frames[i].style.height = Math.ceil(d.details.height) + 'px';
        break;
      }
    }
  });

  document.addEventListener('visitorConsentCollected', updateConsent);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (designMode) {
    updateConsent();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      if (!error) updateConsent();
    });
  }

  window.pmEmbeds = { scan: scan };
  scan(document);
})();
